import React from 'react'
import Layout from '../../components/Layout'

export default () => (
  <Layout>
    <section className="section">
      <div className="container">
        <div style={{ marginTop: '3rem' }} className="column is-10 is-offset-1">
          <div className="content">
            <h1>We'll Be In Touch Soon</h1>
            <p>Thanks for reaching out! I'll get back to you as soon as possible</p>
          </div>
        </div>
      </div>
    </section>
  </Layout>
)
